/* eslint-disable camelcase */
import Liferay from "../utils/Liferay";
import en_US from "./en_US";
import es_PA from "./es_PA";

export const languages = {
  en_US,
  es_PA,
};

/**
 * Traduce una palabra al idioma actual.
 *
 * @param word - Palabra a traducir.
 *
 * @param languageId - Idioma al que se desea traducir.
 *
 * @returns Palabra traducida.
 */
export function translate(
  word,
  languageId = Liferay.ThemeDisplay.getLanguageId(),
) {

  const languageProperties = (languages)[languageId] || Liferay.ThemeDisplay.getDefaultLanguageId();

  return languageProperties[word] || word;

}

const i18n = {
  translate,
};

export default i18n;
